import { schema } from 'normalizr';

export const bandsSchema = new schema.Entity(
  'bands',
  {},
  {
    processStrategy: ({ id, name }) => ({ equivalence: id, name }),
  },
);
